import React, { createContext, useContext, useState } from 'react';

const SeoContext = createContext();

export function SeoProvider({ children }) {
    const [handleOwnSeo, setHandleOwnSeo] = useState(false);

    return (
        <SeoContext.Provider value={{ handleOwnSeo, setHandleOwnSeo }}>
            {children}
        </SeoContext.Provider>
    );
}

export function useSeoContext() {
    const context = useContext(SeoContext);
    if (!context) {
        throw new Error('useSeoContext must be used within a SeoProvider');
    }
    return context;
}

